/* eslint-disable */
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  ForgotPassword,
  VerifyOTPForgotPassword,
} from "../../service/action-creators/authAction";
import Loader from "../Loader";
import { FaTimes, FaLock, FaChevronRight, FaEnvelope } from "react-icons/fa";

export default function ForgotPasswordDialog(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.auth);
  const isLoading = auth?.isLoading;
  const [step, setStep] = React.useState(1); // 1 = email, 2 = otp
  const [identifier, setIdentifier] = React.useState(""); // email only
  const [otpCode, setOtpCode] = React.useState("");

  const handleClose = () => {
    props.close(false);
    setStep(1);
    setIdentifier("");
    setOtpCode("");
  };

  const handleSubmitIdentifier = (e) => {
    e.preventDefault();
    if (!identifier.trim()) {
      toast.error("Please enter your email address");
      return;
    }
    if (!identifier.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }
    // Send OTP to email only (SMS commented out on backend)
    dispatch(ForgotPassword({ email: identifier.trim() }));
    setStep(2);
  };

  const handleSubmitOtp = (e) => {
    e.preventDefault();
    if (!otpCode.trim()) {
      toast.error("Please enter the OTP code");
      return;
    }
    dispatch(VerifyOTPForgotPassword({ opt_code: otpCode }));
    handleClose();
  };

  if (!props.open) return null;

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "1rem",
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "1rem",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
    animation: "slideUp .25s ease",
  };

  const headerStyle = {
    background: "var(--primaryColor)",
    padding: "1.5rem 1.75rem 1.25rem",
    position: "relative",
    color: "#fff",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    background: "rgba(255,255,255,0.2)",
    border: "none",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#fff",
    fontSize: "14px",
  };

  const bodyStyle = {
    padding: "1.75rem",
  };

  const iconWrapStyle = {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: ".75rem",
    fontSize: "1.3rem",
  };

  const labelStyle = {
    display: "block",
    fontSize: ".8rem",
    fontWeight: 600,
    color: "#555",
    marginBottom: ".4rem",
    textTransform: "uppercase",
    letterSpacing: ".05em",
  };

  const inputStyle = {
    width: "100%",
    padding: ".75rem 1rem",
    border: "1.5px solid #e0e0e0",
    borderRadius: ".6rem",
    fontSize: "1rem",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color .2s",
  };

  const primaryBtnStyle = {
    width: "100%",
    padding: ".85rem",
    background: "var(--primaryColor)",
    color: "#fff",
    border: "none",
    borderRadius: ".6rem",
    fontSize: "1rem",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: ".5rem",
    marginTop: "1.25rem",
  };

  const cancelBtnStyle = {
    width: "100%",
    padding: ".75rem",
    background: "transparent",
    color: "#888",
    border: "1.5px solid #e0e0e0",
    borderRadius: ".6rem",
    fontSize: ".9rem",
    cursor: "pointer",
    marginTop: ".65rem",
  };

  const stepBarStyle = {
    display: "flex",
    gap: ".4rem",
    marginBottom: "1.25rem",
  };

  const stepDotStyle = (active) => ({
    height: "4px",
    flex: 1,
    borderRadius: "4px",
    background: active ? "var(--primaryColor)" : "#e0e0e0",
    transition: "background .3s",
  });

  const otpInputStyle = {
    width: "100%",
    padding: "1rem",
    border: "1.5px solid #e0e0e0",
    borderRadius: ".6rem",
    fontSize: "1.8rem",
    fontWeight: 700,
    letterSpacing: ".4em",
    textAlign: "center",
    outline: "none",
    boxSizing: "border-box",
  };

  const hintBoxStyle = {
    background: "#f0faf5",
    border: "1px solid #c3e8d5",
    borderRadius: ".5rem",
    padding: ".6rem .85rem",
    fontSize: ".8rem",
    color: "#2e7d55",
    marginBottom: "1rem",
    lineHeight: 1.5,
  };

  return (
    <div style={overlayStyle} onClick={(e) => e.target === e.currentTarget && handleClose()}>
      {isLoading && <Loader />}
      <div style={cardStyle}>
        <div style={headerStyle}>
          <button style={closeBtnStyle} onClick={handleClose}>
            <FaTimes />
          </button>
          <div style={iconWrapStyle}>
            {step === 1 ? <FaEnvelope /> : <FaLock />}
          </div>
          <h2 style={{ margin: 0, fontSize: "1.3rem", fontWeight: 700 }}>
            {step === 1 ? "Forgot Password?" : "Enter OTP Code"}
          </h2>
          <p style={{ margin: ".35rem 0 0", fontSize: ".875rem", opacity: 0.85 }}>
            {step === 1
              ? "Enter your email address to receive an OTP"
              : "Enter the OTP code sent to your email"}
          </p>
        </div>

        <div style={bodyStyle}>
          <div style={stepBarStyle}>
            <div style={stepDotStyle(true)} />
            <div style={stepDotStyle(step === 2)} />
          </div>

          {step === 1 ? (
            <form onSubmit={handleSubmitIdentifier}>
              <div style={hintBoxStyle}>
                OTP will be sent to your <strong>email address</strong>.
              </div>
              <label style={labelStyle} htmlFor="identifier">
                Email Address
              </label>
              <input
                style={inputStyle}
                type="email"
                id="identifier"
                placeholder="you@example.com"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoFocus
              />
              <button type="submit" style={primaryBtnStyle}>
                Send OTP Code <FaChevronRight size={12} />
              </button>
              <button type="button" style={cancelBtnStyle} onClick={handleClose}>
                Cancel
              </button>
            </form>
          ) : (
            <form onSubmit={handleSubmitOtp}>
              <p style={{ fontSize: ".875rem", color: "#666", marginBottom: "1rem", marginTop: 0 }}>
                Check your <strong>email inbox</strong> for the OTP code.
              </p>
              <label style={labelStyle} htmlFor="otp_code">
                OTP Code
              </label>
              <input
                style={otpInputStyle}
                type="number"
                id="otp_code"
                placeholder="••••"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value)}
                maxLength={6}
                autoFocus
              />
              <button type="submit" style={primaryBtnStyle}>
                Verify &amp; Continue <FaChevronRight size={12} />
              </button>
              <button
                type="button"
                style={cancelBtnStyle}
                onClick={() => setStep(1)}
              >
                ← Back
              </button>
            </form>
          )}
        </div>
      </div>
      <ToastContainer autoClose={3000} />
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        #identifier:focus, #otp_code:focus {
          border-color: var(--primaryColor) !important;
          box-shadow: 0 0 0 3px rgba(0, 165, 102, 0.12);
        }
      `}</style>
    </div>
  );
}
